import HorizontalTileList from "./HorizontalTileList";

// Web port of TileSectionView
// (LibraryFeature/View/Component/TileSectionView.swift).
//
// A titled section of square tiles, laid out either as a horizontal scroller
// or an adaptive grid. Callers supply the tile for an item and are handed the
// width it should use, so both layouts stay consistent without each caller
// restating the sizing. This is the seam that lets Worship Songs and Playlists
// share everything except their tile.

export const GRID_TILE_WIDTH = 170;
export const SCROLLER_TILE_WIDTH = 160;

export interface TileSectionProps<Item> {
  icon: React.ReactNode;
  title: string;
  items: Item[];
  getKey: (item: Item) => string;
  renderTile: (item: Item, tileWidth: number) => React.ReactNode;
  /** Grid for wide layouts (the app's Home waterfall), scroller for compact. */
  usesGrid?: boolean;
}

export default function TileSection<Item>(props: TileSectionProps<Item>) {
  return <section className="flex flex-col gap-3">
    <SectionTitle icon={props.icon} title={props.title} />

    {props.usesGrid
      ? <div
          className="grid gap-4 px-4"
          style={{
            gridTemplateColumns: `repeat(auto-fill, ${GRID_TILE_WIDTH}px)`,
          }}
        >
          {props.items.map((item) => (
            <div key={props.getKey(item)}>
              {props.renderTile(item, GRID_TILE_WIDTH)}
            </div>
          ))}
        </div>
      : <HorizontalTileList
          items={props.items}
          getKey={props.getKey}
          label={props.title}
          renderTile={(item) => props.renderTile(item, SCROLLER_TILE_WIDTH)}
        />}
  </section>
}

// PlainSectionTitleView: icon + title, secondary colour, medium weight, 16px.
function SectionTitle(props: { icon: React.ReactNode, title: string }) {
  return <h2 className="flex items-center gap-1 px-4 text-base font-medium text-gray-500">
    {props.icon}
    {props.title}
  </h2>
}
